import { type ComponentProps, type FC } from "react";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { MultiLineText } from "@root/shared/components/MultiLineText";
import * as styles from "./styles.css";

type Props = {
  heading: string;
  body: string;
  images?: ImageProps[];
};

type ImageProps = ComponentProps<typeof LazyLoadImage>;

export const ClientBrandContents: FC<Props> = ({ heading, body, images }) => (
  <section className={styles.jobGroupInner}>
    <h3 className={styles.heading}>{heading}</h3>
    <div className="js-toggle-text-area">
      <MultiLineText text={body} />
    </div>
    <div className={styles.imageList}>
      {images &&
        images.map(({ src, alt, width, height, dummyImgPath }) => (
          <div key={src} className={styles.column}>
            <LazyLoadImage
              key={src}
              src={src}
              dummyImgPath={dummyImgPath}
              alt={alt}
              width={width}
              height={height}
            />
          </div>
        ))}
    </div>
  </section>
);
